<template>
	<div class="pcon">
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<div class="listBox f-bct">
					<div class="smallBox">
						<!-- 选项卡 -->
						<div class="navBox f-bct">
							<p class="a">Консолидации</p>
							<p @click="back()">Вернуться на предыдущую страницу</p>
						</div>
						<!-- 筛选 -->
						<div class="shaixuan f-ct">
							<div class="l f-ct">
								<div class="itm">
									<span style="margin-right: 0.1rem;">Состояние</span>
									<el-select v-model="value" placeholder="请选择">
									<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value">
									</el-option>
									</el-select>
								</div>
								<div class="itm1">
									<el-image :src="require('@/static/icon29.png')"></el-image>
									<el-input type="text" v-model="keyword" placeholder="Пожалуйста, введите номер заказа"></el-input>
								</div>
							</div>
							<div class="seachBtn f-ct">
								<div @click="courseOrderlist(1)">поиск</div>
							</div>
						</div>
						<!-- 大包裹列表 -->
						<div class="smallList">
							<div class="itm" v-for="(item,index) in orderList">
								<div class="sn f-bct">
									<div class="t1 f-ct">
										Номер накладной：<span>{{item.bigExpressNumber}}</span>
									</div>
									<div class="t2" v-if="item.status == 2">Собирайся.</div>
									<div class="t2" v-if="item.status == 3">Упакован.</div>
									<div class="t2" v-if="item.status == 4">Отправлено.</div>
									<div class="t2" v-if="item.status == 5">Доставлено.</div>
								</div>
								<div class="detail f-ct">
									<div class="msg f-ct">
										<el-image class="img" @click="showImgViewer([item.imageUrl])" v-if="item.imageUrl" :src="item.imageUrl"></el-image>
										<el-image class="img" v-else :src="require('@/static/img4.png')"></el-image>
										<div class="r f-ct">
											<div class="cBox f-ct">
											<div class="nubitm">
												<el-image :src="require('@/static/icon17.png')"></el-image>
												<p>длина：{{item.length||'？'}}cm</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon18.png')"></el-image>
												<p>ширина：{{item.width||'？'}}cm</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon19.png')"></el-image>
												<p>высота：{{item.height||'？'}}cm</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon32.png')"></el-image>
												<p>Плотность：{{item.density||'？'}}KG/m³</p>
											</div>
											</div>
											<div class="cBox f-ct">
											<div class="nubitm">
												<el-image :src="require('@/static/icon20.png')"></el-image>
												<p>объём：{{item.volume||'？'}}cm³</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon21.png')"></el-image>
												<p>Вес：{{item.weight||'？'}}kg</p>
											</div>
											<div class="nubitm">
												<el-image :src="require('@/static/icon22.png')"></el-image>
												<p>Количество трек-номеров：{{item.miniPackageNum||'？'}}</p>
											</div>
											</div>
										</div>
									</div>
									<div class="f-ct" style="justify-content: flex-end;width: 3.05rem;">
										<div class="dabaoMan f-ct" v-if="item.status!=2">
											<p>Пакер：</p>
											<el-image v-if="item.packerPortrait" :src="item.packerPortrait"></el-image>
											<el-image v-else :src="require('@/static/uzw.png')"></el-image>
											<p>{{item.packerName}}</p>
										</div>
										<div class="bor"></div>
										<div class="caozuo">
											<!-- <p class="t1" @click="link('/bigBagMsg')">查看物流</p> -->
											<p class="t3" @click="link('/bigBagMsg',{id:item.id})">проверьте детали</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 暂无 -->
						<div class="zw" v-if="!orderList.length">
							<el-image :src="require('@/static/zw1.png')"></el-image>
							<p class="t1">Данные о пакете пока отсутствуют</p>
						</div>
						<!-- 分页 -->
						<div class="fenye">
							<el-pagination
							background
							hide-on-single-page
							layout="prev, pager, next,jumper"
							@current-change="goPage"
							:page-size="pageSize"
							:total="total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 删除 -->
		<div class="maskBg" v-if="hbDel1"></div>
		<div class="subTips" style="width: 402px;" v-if="hbDel1">
			<el-image class="cha" :src="require('@/static/icon26.png')"></el-image>
			<div class="txt">Удалите приказ</div>
			<div class="t1">您确定要删除此订单吗？</div>
			<div class="btnBox f-ct" style="margin-top: 30px;">
				<div class="b1" @click="hbDel1=false">返回</div>
				<div class="b2" @click="backNub(0)">确定</div>
			</div>
		</div>
		<!-- 图片预览 -->
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
	</div>
</template>
<script>
import { packageBigList } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	components: {
		'leftBox': () => import('@/components/leftBox.vue'),
		'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
	},
	data(){
		return {
			imgViewerVisible:false,
			imgList:[],
			
			keyword:'',
			options: [
				{
					value: '0',label: 'Все'
				},
				{
					value: '2',label: 'На сборке'
				}, 
				{
					value: '3',label: 'Упакованы'
				}, 
				{
					value: '4',label: 'Отправлены'
				}, 
				{
					value: '5',label: 'Доставлены'
				},
			],
			value: '0',
			// 分页
			orderList:[],
			pageNum:1,
			pageSize:10,
			total:40,
		}
	},
	mounted() {
		this.value = this.$route.query.value||'0'
		this.courseOrderlist(1)
	},
	methods:{
		// 图预览
		showImgViewer(arr){
			this.imgList = arr
			this.imgViewerVisible = true;
			const m = (e) => { e.preventDefault() };
		},
		closeImgViewer(){
			this.imgViewerVisible = false;
		},
		// 查询课程列表
		async courseOrderlist(def){
			if(def){this.pageNum=1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			}
			if(this.value*1){
				data.status = this.value*1
			}
			if(this.keyword){
				data.bigExpressNumber = this.keyword
			}
			let res = await packageBigList(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.orderList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			this.pageNum = e
			this.courseOrderlist()
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.pcon{
	padding: 0 74px;
	padding-bottom: 46px;
}
.banner{
	width: 100%;
	height: 413px;
	.el-image{
		width: 100%;
		height: 413px;
		border-radius: 18px;
	}
	.dian{
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 16px;
		z-index: 2;
		div{
			margin: 0 3px;
			width: 8px;
			height: 8px;
			border-radius: 8px;
			background: #00000033;
			transition:0.3s;
		}
		.a{
			background: #fff;
			width: 14px;
			transition:0.3s;
		}
	}
}
.pageCon{
	margin-top: 32px;
	justify-content: space-between;
	.pageConL{
		width: 530px;
	}
	.pageConR{
		width: calc(100% - 562px);
		.userNub{
			.itm{
				width: 382px;
				height: 158px;
				border-radius: 12px;
				background: #fff;
				padding-right: 46px;
				padding-left: 36px;
				.el-image{
					width: 80px;
				}
				.txt{
					width: calc(100% - 90px);
					margin-right: 10px;
					.t1{
						font-size: 42px;
						font-weight: bold;
					}
					.t2{
						font-size: 20px;
						color: #666666;
					}
				}
			}
		}
		.listBox{
			.tit{
				.tl{
					display: flex;
					align-items: center;
					.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
					p{
						font-size: 18px;
						padding-left: 10px;
					}
				}
				.tr{
					display: flex;
					align-items: center;
					.el-image{
						width: 20px;
					}
					p{
						font-size: 16px;
						color: #666666;
					}
				}
			}
			.zw{
				padding-top: 0;
				.el-image{
					margin-bottom: 0;
				}
			}
			.smallBox{
				width: 100%;
				// height: 411px;
				background: #fff;
				border-radius: 12px;
				padding: 24px;
				.smallList{
					margin-top: 16px;
					// height: 340px;
					// background: pink;
					// overflow: scroll;
					.itm{
						border: 1px solid #EFF1F6;
						border-radius: 8rpx;
						margin-bottom: 16px;
						.sn{
							height: 56px;
							border-bottom: 1px solid #EFF1F6;
							background: #EFF1F6;
							padding: 0 24px;
							.el-image{
								display: block;
								width: 20px;
								margin-right: 12px;
								// margin-left: 24px;
							}
							.t1{
								font-size: 16px;
								color: #999999;
								span{
									color: #333;
								}
							}
							.t3{
								.snTxt{
									font-size: 16px;
									color: #999999;
									span{
										color: #333;
									}
								}
								.bor{
									width: 1px;
									height: 16px;
									background: #D9D9D9;
									margin: 0 24px;
								}
								.man{
									font-size: 16px;
								}
							}
							.t2{
								padding: 0 6px;
								// width: 72px;
								height: 30px;
								background: #C7F3F5;
								font-size: 14px;
								color: #38ABB0;
								text-align: center;
								line-height: 30px;
								border-radius: 4px;
							}
						}
						.detail{
							padding: 16px 0;
							.dabaoMan{
								padding-right: 32px;
								p{
									font-size: 16px;
								}
								.el-image{
									width: 22px;
									height: 22px;
									border-radius: 50%;
									margin-right: 6px;
								}
							}
							.msg{
								width: calc(100% - 305px);
								padding-left: 24px;
								// background: pink;
								.img{
									width: 66px;
									height: 66px;
									border-radius: 6px;
									margin-right: 16px;
								}
								.r{
									width: calc(100% - 82px);
									.cBox{
										margin-bottom: 10px;
										&:last-child{
											margin-bottom: 0;
										}
									}
									.nubitm{
										display: flex;
										align-items: center;
										// margin-right: 63px;
										width: 176px;
										.el-image{
											width: 20px;
											height: 20px;
											margin-right: 6px;
										}
										p{
											font-size: 16px;
										}
									}
								}
							}
							.bor{
								width: 1px;
								height: 50px;
								background: #D9D9D9;
							}
							.caozuo{
								width: 104px;
								// background: #00000033;
								p{
									text-align: center;font-size: 14px;
									cursor: pointer;
								}
								.t1{
									color: #38ABB0;
								}
								.t2{
									color: #FF4D5A;
									margin-top: 6px;
								}
								.t3{
									color: #38ABB0;
									margin-top: 6px;
								}
							}
						}
					}
				}
			}
			.mtBox{
				width: 382px;
				height: 411px;
				background: #fff;
				border-radius: 12px;
				padding: 24px;
				.maitouList{
					margin-top: 16px;
					height: 330px;
					// background: pink;
					overflow: scroll;
					.mtItm{
						margin-bottom: 22px;
						.l{
							.nub{
								// width: 20px;
								height: 20px;
								background: #38ABB0;
								margin-right: 12px;
								color: #fff;
								border-radius: 20px;
								font-size: 13px;
								text-align: center;
								line-height: 19px;
								padding: 0 5px;
								padding-left: 6px;
							}
							.el-image{
								width: 45px;
							}
							p{
								font-size: 16px;
								padding-left: 6px;
							}
						}
						.r{
							display: flex;
							align-items: center;justify-content: flex-end;
							.bor{
								width: 1px;
								height: 16px;
								margin: 0 10px;
								background: #D9D9D9;
							}
							.btnItm{
								display: flex;
								align-items: center;
								.el-image{
									width: 14px;
									margin-right: 4px;
								}
								p{
									font-size: 14px;
								}
								.t1{
									color: #38ABB0;
								}
								.t2{
									color: #FF4D5A;
								}
							}
						}
					}
				}
				.tableImgList{
					margin-top: 16px;
					height: 340px;
					// background: pink;
					overflow: scroll;
					.el-image{
						width: 100%;
						height: 154px;
						margin-bottom: 16px;
						border-radius: 12px;
					}
				}
			}
		}
	}
}
.shaixuan{
	padding: 0 24px;
	padding-top: 24px;
	margin-bottom: 24px;
	padding-left: 0;
	.l{
		.itm{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
		}
		.itm1{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			border: 1px solid #DDDDDD;
			border-radius: 4px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
			::v-deep .el-input__inner{
				background: none;
				border: none;
				padding-left: 0;
			}
			.el-image{
				display: block;
				width: 16px;
				margin-left: 16px;
				margin-right: 12px;
			}
		}
	}
	.seachBtn{
		transform: translateX(-12px);
		div{
			width: 85px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
}
.rukuSel{
	.l{
		.el-image{
			width: 20px;
			margin-right: 12px;
		}
		span{
			font-size: 14px;
		}
	}
	.seachBtn{
		p{
			font-size: 14px;
			padding-right: 16px;
		}
		div{
			width: 128px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
		}
	}
}
.navBox{
	border-bottom: 1px solid #EEEEEE;
	// padding: 0 10px;
	p{
		// padding-top: 24px;
		padding-bottom: 16px;
		// margin-right: 56px;
		font-size: 18px;
		cursor: pointer;
		color: #7D7D89;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			border-radius: 4px;
			background: #38ABB0;
			bottom: 0%;
			left: 50%;
			transform: translateX(-50%);
			transition:0.3s;
		}
	}
	.a{
		color: #38ABB0;
		font-weight: bold;
		&::after{
			width: 100%;
			transition:0.3s;
		}
	}
}
.fenye{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 26px;
}
::v-deep .active{
	background: #38ABB0!important;
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 764px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.title{
		height: 69px;
		padding: 0 30px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 40px;
		.el-image{
			width: 14px;
		}
		p{
			font-size: 18px;
		}
	}
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.txt{
		font-size: 18px;
		font-weight: 600;
		color: #2F3541;
		margin-top: 35px;
		text-align: center;
	}
	.t1{
		font-size: 18px;
		color: #7D7D89;
		// font-weight: 600;
		text-align: center;
		margin-top: 25px;
		span{
			color: #38ABB0;
			padding: 0 4px;
		}
	}
	.t2{
		font-size: 18px;
		color: #FF5F5A;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.t3{
		font-size: 14px;
		color: #999999;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.dabaoFrom{
		.selBox{
			width: 95%;
			margin: auto;
			border-radius: 6px;
			margin-bottom: 20px;
			height: 56px;
			border: 1px solid #DDDDDD;
			padding-left: 16px;
			padding-right: 24px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.el-select{
				// background: pink;
				width: calc(100% - 100px);
			}
			::v-deep .el-input__inner{
				border: none;
				text-align: right;padding: 0;
			}
			::v-deep .el-input__suffix{
				display: none;
			}
			.lab{
				font-size: 14px;
			}
			.el-image{
				width: 10px;
				margin-left: 16px;
			}
		}
	}
	.nubtips{
		width: 95%;
		margin: auto;
		color: #FF4D5A;
		font-size: 14px;
	}
	.snBox{
		width: 95%;
		margin: auto;
		background: #F6F6F6;
		height: 142px;
		overflow: scroll;
		padding: 16px 20px;
		border-radius: 6px;
		margin-top: 16px;
		font-size: 14px;
	}
	.iptBox{
		width: 403px;
		margin: auto;
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.lab{
			font-size: 16px;
			color: #9A9DA7;
			width: calc(100% - 307px);
		}
		.ipt{
			width: 307px;
			border: 1px solid #E8EDF4;
			border-radius: 8px;
			padding: 0 20px;
			height: 50px;
			display: flex;
			align-items: center;
			::v-deep .el-input__inner{
				border: none;
				padding: 0 0;
				font-size: 0.16rem;
				background: none;
			}
			.selItm{
				display: flex;
				align-items: center;
				margin-right: 80px;
				.el-image{
					width: 20px;
					margin-right: 8px;
				}
				p{
					font-size: 16px;
				}
			}
		}
	}
	.btnBox{
		margin-top: 42px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #F6F6F6;
			color: #666;
		}
		.b2{
			background: #38ABB0;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>